import { loadStripe } from '@stripe/stripe-js';
import { resolveStripePublishableKey } from '../utils/stripeConfig';

const stripeConfiguration = resolveStripePublishableKey(process.env);

export const stripeConfigurationError = stripeConfiguration.error;
export const stripeConfiguredMode = stripeConfiguration.mode || null;

const stripePromise = stripeConfiguration.key
  ? loadStripe(stripeConfiguration.key)
  : null;

export default stripePromise;
